"use client";

import Image from "next/image";
import Link from "@/components/ui/Link";
import { MessageIcon } from "../ui/message-icon";
import { Frame } from "@/components/ui/frame";
import { BOOKMARK_CATEGORIES } from "@/lib/api/public-client";
import { FALLBACK_IMAGE } from '@/lib/constants';
import { getImageUrl, getTimeAgo, getFocusPointStyle, ImageMetadata, BLUR_PLACEHOLDER } from '@/lib/componentutills';

type FieldConfig = {
  hidden?: boolean;
  value?: string;
  customClass?: string;
};

type Props = {
  category?: FieldConfig;
  title?: FieldConfig;
  timeAgo?: FieldConfig;
  imageSrc?: FieldConfig;
  className?: string;
  slug?: string;
  /** Mark as LCP image - preloads for faster rendering */
  priority?: boolean;
  imageMetadata?: ImageMetadata;
};

export const VerticalBigImagesNews = ({
  title = { hidden: false, value: "ஷாலினி மற்றும் குழந்தைகள் அனுஷ்கா, ஆத்விக் ஆகியோர் ஷாம்லி கலைக் கண்காட்சியில் கலந்து கொண்டனர்", customClass: "" },
  timeAgo = { hidden: false, value: "Wed, 17May 2023", customClass: "" },
  imageSrc = { hidden: false, value: FALLBACK_IMAGE, customClass: "" },
  slug,
  priority = false,
  imageMetadata,
}: Props) => {
  const titleValue = title?.value || "";
  const timeAgoValue = getTimeAgo(timeAgo?.value);
  const imageSrcValue = getImageUrl(imageSrc?.value) || FALLBACK_IMAGE;
  const content = (
    <div className="flex flex-col overflow-hidden p-4 gap-4">
      {/* IMAGE — single aspect-ratio across breakpoints stops the height jumping
          between mobile (16/9) and desktop (fixed 431px). aspect-[16/9] sits
          inside both flow modes consistently. */}
      {!imageSrc?.hidden && (
        <div className={imageSrc?.customClass || ""}>
          <div className="relative w-full aspect-[16/9] overflow-hidden">
            <Image
              src={imageSrcValue}
              alt={titleValue}
              fill
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 66vw, 800px"
              priority={priority}
              className="object-cover"
              style={getFocusPointStyle(imageMetadata)}
              loading={priority ? "eager" : "lazy"}
              fetchPriority={priority ? "high" : "auto"}
              placeholder="blur"
              blurDataURL={BLUR_PLACEHOLDER}
            />
            {/* <div className="absolute bottom-2 right-2">
              <Frame id="8" />
            </div> */}
          </div>
        </div>
      )}

      {/* Title — min-height = 2 lines @ 18px × 1.4 leading = ~50px so 1-line and
          2-line titles occupy the same space, removing card-height variance CLS. */}
      {!title?.hidden && (
 <h3 className={`text-18-tamil-700 md:text-18-tamil-700 lg:text-18-tamil-700 text-000000 leading-[1.4] whitespace-pre-line min-h-[3em] ${title?.customClass || ""}`}>
          {titleValue}
        </h3>
      )}

      {/* Footer */}
      <div className="flex justify-between items-center text-000000 gap-2">
        {!timeAgo?.hidden && (
          <span className={`text-12-tamil-500 ${timeAgo?.customClass || ""}`}>{timeAgoValue}</span>
        )}
        <div className="flex gap-3">
          <MessageIcon
            id="message-icon-4"
            slug={slug}
            category={BOOKMARK_CATEGORIES.PHOTOS}
            title={titleValue}
            thumbnailUrl={imageSrcValue}
            articleUrl={slug ? `/${slug}` : undefined}
          />
        </div>
      </div>
    </div>
  );

  if (slug) {
    return (
      <Link href={`/${slug}`} className="block hover:opacity-90 transition-opacity cursor-pointer">
        {content}
      </Link>
    );
  }

  return content;
};